import React, { useState, useEffect, useRef } from "react";
import "./Testimonial.css";

const testimonials = [
  {
    img: "https://user-images.githubusercontent.com/13468728/234031693-6bbaba7d-632c-4d7d-965f-75a76a549ce2.jpg",
    name: "Zen",
    title: "Author",
    desc: "Zen Doan is a business analyst, entrepreneur and media proprietor, and investor. She is also known as the best-selling book author."
  },
  {
    img: "https://user-images.githubusercontent.com/13468728/234031617-2dfb19ea-01d0-4370-b63b-bb6bdfb4f78e.jpg",
    name: "Jonathan",
    title: "Treymont Inc.",
    desc: "Jonathan Koletic is an American internet entrepreneur and media proprietor, and investor. He is the founder of the multi-national technology company Treymont."
  },
  {
    img: "https://user-images.githubusercontent.com/13468728/234031646-10533999-39e5-4c7b-ab54-d0299b13ce74.jpg",
    name: "Charlie",
    title: "Hallmark Inc.",
    desc: "Charlie Green is an European entrepreneur and media consultant, and investor. He is the founder of the Hallmark Inc."
  },
  {
    img: "https://github.com/ecemgo/ecemgo/assets/13468728/55116c98-5f9a-4b0a-9fdb-4911b52d5ef3",
    name: "Sarah",
    title: "Zara Inc.",
    desc: "Sarah Dam is an American internet entrepreneur and media proprietor, and investor. She is the founder of the multi-national technology company Zara."
  }
];

const Testimonial = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const slideRowRef = useRef(null);
  const mainRef = useRef(null);

  const updateSlide = () => {
    const mainWidth = mainRef.current.offsetWidth;
    const translateValue = currentIndex * -mainWidth;
    slideRowRef.current.style.transform = `translateX(${translateValue}px)`;

    const indicators = document.querySelectorAll(".btn");
    indicators.forEach((btn, index) => {
      btn.classList.toggle("active", index === currentIndex);
    });
  };

  const handleIndicatorClick = (index) => {
    setCurrentIndex(index);
  };

  // Update slide position on `currentIndex` change
  useEffect(() => {
    updateSlide();
  }, [currentIndex]);

  // Automatically change slide every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 4000); // Change slide every 4 seconds

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

  // Update slide position on window resize
  useEffect(() => {
    const handleResize = () => updateSlide();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div id="testimonials"
      style={{
       background:'linear-gradient(-89deg, #E6735E, #F25F36 28%, #DB1A88 82%, #FF0091)',
        backgroundRepeat: "no-repeat",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        paddingBottom: "10px",
        paddingTop: "10px",

      }}
      py={5}
    >
      <main ref={mainRef} className="testimonials-main">
        <h1
          style={{
            textAlign: "center",
            fontSize: "clamp(2rem, 4vw, 2.6rem)",
            color: "#fff",
            marginBottom: "10px",
            fontWeight:'bold'
          }}
        >
          Testimonials
        </h1>

        {/* Testimonials Slider */}
        <div className="testimonials_slider">
          <div
            className="testimonials-slide-row"
            ref={slideRowRef}
            style={{
              display: "flex",
              transition: "transform 0.5s ease-in-out"
            }}
          >
            {testimonials.map((testimonial, index) => (
              <div className="testimonials-slide-col" key={index}>
                <div className="testimonials-content">
                  <p>{testimonial.desc}</p>
                  <h2>{testimonial.name}</h2>
                  <p style={{marginTop:'4px'}}>{testimonial.title}</p>
                </div>
                <div className="testimonials-hero">
                  <img src={testimonial.img} alt={`${testimonial.name} avatar`} />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Indicators */}
        <div className="indicator">
          {testimonials.map((_, index) => (
            <span
              key={index}
              className={`btn ${index === currentIndex ? "active" : ""}`}
              onClick={() => handleIndicatorClick(index)}
            ></span>
          ))}
        </div>
      </main>
    </div>
  );
};

export default Testimonial;
